import script from "./CaptureKeys.vue?vue&type=script&setup=true&lang=js"
export * from "./CaptureKeys.vue?vue&type=script&setup=true&lang=js"

import "./CaptureKeys.vue?vue&type=style&index=0&id=ccede38a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ccede38a"]])

export default __exports__